import { render, staticRenderFns } from "./dingwei.vue?vue&type=template&id=8ce1bca0"
import script from "./dingwei.vue?vue&type=script&lang=js"
export * from "./dingwei.vue?vue&type=script&lang=js"
import style0 from "./dingwei.vue?vue&type=style&index=0&id=8ce1bca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports